import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useContext } from "react";

const PRODUCT_FLAG_KEYS = [
  FeatureFlagKey.MERCHANT_RECLAIM_ONBOARDING_ASYNC,
  FeatureFlagKey.SHOPPER_AGENT,
] as const;

/**
 * Returns true when at least one setup-guide product is enabled for the
 * current team. Returns false until team data has loaded so the widget never
 * renders with stale or missing flag state.
 */
export function useAnySetupGuideProductEnabled(): boolean {
  const team = useContext(TeamContext);
  if (!team) {
    return false;
  }
  const setupGuideFlags = team.featureFlags as
    | Partial<Record<(typeof PRODUCT_FLAG_KEYS)[number], boolean>>
    | undefined;
  return PRODUCT_FLAG_KEYS.some(
    (flagKey) => setupGuideFlags?.[flagKey] === true,
  );
}

export function isShopperAgentPhoneProvisioningEnabled(team: unknown): boolean {
  const flags = (team as { featureFlags?: unknown } | null | undefined)
    ?.featureFlags as Partial<Record<FeatureFlagKey, boolean>> | undefined;
  return (
    flags?.[FeatureFlagKey.MERCHANT_SHOPPER_AGENT_ONBOARDING_ASYNC] === true
  );
}

/**
 * Deprecated alias kept to avoid a broad rename in older callers.
 */
export function useReclaimAsyncOnboardingEnabled(): boolean {
  return useAnySetupGuideProductEnabled();
}
